'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { MouseEvent, Ref } from 'react';
import { OptimizedImage } from '@/components/images';
import { APP_STORE_URL, type AppUpsellEntryPoint, GOOGLE_PLAY_URL } from '@/config/app-upsells';
import { onEvent } from '@/events';
import type { AppUpsellSurface } from '@/events/app-upsells';
import { appUpsellProperties } from '@/lib/app-upsells/analytics';
import { cn } from '@/lib/ui/utils';
const STORES = [{
  destination: 'app_store',
  href: APP_STORE_URL,
  image: 'app-store',
  size: 'h-10 aspect-[119.66407/40]'
}, {
  destination: 'google_play',
  href: GOOGLE_PLAY_URL,
  image: 'google-play',
  size: 'h-10 aspect-[238.96/70.87]'
}] as const;
export function AppStoreLinks(t0) {
  const $ = _c(16);
  const {
    ref,
    surface,
    entryPoint,
    location: t1,
    className,
    onAfterAction,
    onClick
  } = t0;
  const location = t1 === undefined ? surface : t1;
  const t = useTranslations("app_upsells");
  let t2;
  if ($[0] !== entryPoint || $[1] !== onAfterAction || $[2] !== onClick || $[3] !== surface) {
    t2 = function recordClick(event, destination) {
      onClick?.(event);
      onEvent("app_upsell_clicked", {
        ...appUpsellProperties(surface, entryPoint),
        destination: event.defaultPrevented ? "dialog" : destination
      });
      const modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1;
      if (!modified && !event.defaultPrevented) {
        onAfterAction?.();
      }
    };
    $[0] = entryPoint;
    $[1] = onAfterAction;
    $[2] = onClick;
    $[3] = surface;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const recordClick = t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("flex flex-wrap items-center gap-x-6 gap-y-3 py-2.5", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `app-store-links-${location}`;
  let t5;
  if ($[7] !== recordClick || $[8] !== surface || $[9] !== t) {
    t5 = STORES.map(store => <a key={store.destination} data-testid={surface === "navigation" && store.destination === "app_store" ? "app-download-navigation" : undefined} aria-label={store.destination === "app_store" ? t("app_store_badge") : t("google_play_badge")} href={store.href} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 shrink-0 items-center rounded-control focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-foreground-brand" onClick={event_0 => recordClick(event_0, store.destination)} onAuxClick={event_1 => {
      if (event_1.button === 1) {
        recordClick(event_1, store.destination);
      }
    }}><OptimizedImage variant="thumbnail" src={`/images/app-upsells/${store.image}.svg`} alt="" size={store.size} rounded="" priority={surface === "navigation" || surface === "dialog"} className="bg-transparent" imageClassName="object-contain" preview={false} nsfw={false} loadReveal="none" /></a>);
    $[7] = recordClick;
    $[8] = surface;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== ref || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div ref={ref} className={t3} data-testid={t4}>{t5}</div>;
    $[11] = ref;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}